export const ARTICLE_FALLBACK_LANGUAGE = 'pr-unknown';
